import {
    fetchGroup,
    fetchGroups,
    createGroup,
    putGroups,
    deleteGroup,
    removeOrRestoreUserByEmailRoutine,
    removeUserRoutine,
    addUserToGroup,
    updateUserInGroup, restoreGroupRoutine,
} from "../../routines";

const CLEAR_SINGLE_GROUP = "CLEAR_SINGLE_GROUP";

export const clearSingleGroup = () => ({
    type: CLEAR_SINGLE_GROUP,
});

export const groupsReducer = (state: any = { source: [], singleGroup: null, isLoading: true, exception: null }, action: any) => {
    switch (action.type) {
        case fetchGroup.TRIGGER:
            return {
                ...state,
                singleGroup: state.singleGroup,
                isLoading: true
            };
        case fetchGroups.TRIGGER:
            return {
                ...state,
                source: state.source,
                isLoading: true
            };
        case fetchGroup.SUCCESS:
            return {
                ...state,
                singleGroup: action.payload,
                isLoading: false
            };
        case fetchGroups.SUCCESS:
            return {
                ...state,
                source: action.payload,
                isLoading: false
            };
        case createGroup.TRIGGER: {
            return {
                ...state,
                source: state.source,
                isLoading: true
            }
        }
        case createGroup.SUCCESS: {
            return {
                ...state,
                source: [...state.source, action.payload],
                isLoading: false
            };
        }
        case createGroup.FAILURE: {
            return {
                ...state,
                source: state.source,
                isLoading: false,
                exception: "error"
            }
        }
        case restoreGroupRoutine.SUCCESS: {
            const index = state!.source.findIndex(group => group.id === action.payload);
            const itemToRestore = { ...state!.source[index] }

            return {
                ...state,
                source: [...state!.source.slice(0, index), {...itemToRestore, isDeleted: false}, ...state!.source.slice(index + 1, state!.source.length)],
                isLoading: false
            }
        }
        case removeOrRestoreUserByEmailRoutine.SUCCESS: {
            const index = state.singleGroup?.users.findIndex(u => u.id === action.payload.id);
            const item = { ...state.singleGroup?.users[index] }
            item.isDeleted = action.payload.isDeleted;
            return {
                ...state,
                singleGroup: {
                    ...state.singleGroup,
                    users: [...state.singleGroup.users.slice(0, index), item, ...state.singleGroup.users.slice(index + 1, state.singleGroup.users.length)]
                },
                isLoading: false
            }
        }
        case removeUserRoutine.SUCCESS: {
            return {
                ...state,
                singleGroup: {
                    ...state.singleGroup,
                    users: state!.singleGroup?.users.filter(x => x.id !== action.payload)
                },
                isLoading: false
            }
        }
        case addUserToGroup.SUCCESS: {
            return {
                ...state,
                singleGroup: {
                    ...state.singleGroup,
                    users: !action.payload.error
                        ?
                        [
                            ...state.singleGroup.users,
                            action.payload.user
                        ]
                        : state.singleGroup?.users
                },
                isLoading: false,
                exception: action.payload.error
            }
        }
        case updateUserInGroup.SUCCESS: {
            const index = state.singleGroup?.users.findIndex(u => u.id === action.payload.id);

            return {
                ...state,
                singleGroup: {
                    ...state.singleGroup,
                    users: [
                        ...state.singleGroup.users.slice(0, index),
                        action.payload,
                        ...state.singleGroup.users.slice(index + 1)
                    ]
                },
                isLoading: false
            }
        }
        case deleteGroup.SUCCESS:
            if (action.payload.hardDelete) {
                return {
                    ...state,
                    source: [...state.source.filter(x => x.id !== action.payload.groupId)],
                    isLoading: false
                };
            } else {
                const index = state!.source.findIndex(group => group.id === action.payload.groupId);
                const softDeletedGroup = { ...state!.source[index] }

                return {
                    ...state,
                    source: [...state!.source.slice(0, index), {...softDeletedGroup, isDeleted: true}, ...state!.source.slice(index + 1, state!.source.length)],
                    isLoading: false
                }
            }

        case putGroups.TRIGGER: {
            return {
                ...state,
                source: state.source,
                isLoading: true
            }
        }
        case putGroups.SUCCESS:
            const index = state.source.findIndex(u => u.id === action.payload.id);
            return {
                ...state,
                source: [
                    ...state.source.slice(0, index),
                    action.payload,
                    ...state.source.slice(index + 1, state!.source.length)
                ],
                isLoading: false
            };
        case putGroups.FAILURE: {
            return {
                ...state,
                source: state.source,
                isLoading: false,
                exception: "error"
            }
        }
        case "CLEAR_SINGLE_GROUP": {
            return {
                ...state,
                singleGroup: null
            }
        }

        default:
            return state
    }
}
